import { useEffect, useState } from "react";
import Api from "../openapi";
import { DiscountBriefResponse } from "../openapi/client";

export default function useDiscount(refresh?: number) {
  const [discountList, setDiscountList] = useState<DiscountBriefResponse[]>([]);

  useEffect(() => {
    const getDiscounts = async () => {
      try {
        const res = await Api.Discount.listBriefDiscounts();
        setDiscountList(res.data);
      } catch (error) {}
    };
    getDiscounts();
  }, [refresh]);
  return discountList;
}
